module.exports = __webpack_public_path__ + "bcbfcfc4e97651efdc210d812ce3df9d.jpg";